
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.805 12.138L10 5.943 7.057 3 .862 9.195a.669.669 0 00-.175.31L0 13l3.495-.687a.668.668 0 00.31-.175zM12 3.943c.52-.521.52-1.365 0-1.886L10.943 1a1.333 1.333 0 00-1.886 0L8 2.057 10.943 5 12 3.943z","fill":"#7E8186"}})])
          )
        }
      }
    